module.exports = __webpack_public_path__ + "static/assets/5e0c4b8a7ecd6589911872447d7233f5.gif";